import StudioMedico from "../";

const routes = [{ name: "Home Studio Medico", path: "/homestudiomedico", component: StudioMedico.HomeStudioMedicoList, meta: { title: "home.lblTitle" } }];

export default routes;
